export let AppTileSource = /*#__PURE__*/function (AppTileSource) {
  AppTileSource["MPAC"] = "MPAC";
  AppTileSource["PRODUCT"] = "PRODUCT";
  return AppTileSource;
}({});
export let Certification = /*#__PURE__*/function (Certification) {
  Certification["CLOUD_FORTIFIED"] = "CLOUD_FORTIFIED";
  Certification["CLOUD_SECURITY_PARTICIPANT"] = "CLOUD_SECURITY_PARTICIPANT";
  return Certification;
}({});
export let BadgeVariant = /*#__PURE__*/function (BadgeVariant) {
  BadgeVariant["FEATURED"] = "FEATURED";
  BadgeVariant["POPULAR"] = "POPULAR";
  BadgeVariant["NOTEWORTHY"] = "NOTEWORTHY";
  return BadgeVariant;
}({});